// style.jsx
import React from 'react';
import { styled } from '@mui/material/styles';
import Slider from 'react-slick';

/* Main Slick Slider wrapper */
export const SlickSlider = styled(Slider)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  width: 300,
  maxWidth: '100%',
  display: 'flex',
  alignItems: 'center',

  '.slick-track': {
    display: 'flex',
    alignItems: 'center'
  }
}));

/* Arrow buttons for navigation */
export const SliderArrow = styled(
  ({ $left, $right, currentSlide, slideCount, ...rest }) =>
    React.createElement('div', rest)
)(({ theme, $left, $right }) => ({
  alignItems: 'center',
  display: 'flex !important',
  fontWeight: theme.fontWeight.bold,
  justifyContent: 'center',
  left: $left ? theme.spacing(-1) : 'auto',
  right: $right ? theme.spacing(-0.25) : 'auto',
  position: 'absolute',
  top: '50%',
  transform: 'translate(0, -50%)',
  zIndex: 99,
  cursor: 'pointer',
  '& svg': {
    height: 24,
    width: 24
  }
}));


/* Individual item wrapper */
export const ItemContent = styled('div')(({ theme }) => ({
  textAlign: 'center',
  color: theme.color.text.light,
  fontSize: theme.fontSize.small,
  padding: theme.spacing(0.3, 3, 0, 2),
  boxSizing: 'border-box',
  display: 'flex !important',
  justifyContent: 'center',
  alignItems: 'center'
}));
